import { useState, useEffect, useRef } from "react"
import cowsVideo from "@/assets/cows_video.mp4"
import logisticsVideo from "@/assets/logistics_video.mp4"
import meatVideo from "@/assets/meat_video.mp4"
import grillingVideo from "@/assets/grilling_video.mp4"

const videoSources = [cowsVideo, logisticsVideo, meatVideo, grillingVideo]

const VideoBackground = () => {
  const [currentVideo, setCurrentVideo] = useState(0)
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load()
      const playPromise = videoRef.current.play()
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          if (error.name !== "AbortError") {
            console.error("Video playback error:", error)
          }
        })
      }
    }
  }, [currentVideo])

  const handleVideoEnd = () => {
    setCurrentVideo((prev) => (prev + 1) % videoSources.length)
  }

  return (
    <div className="absolute inset-0 z-0">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnd}
        className="h-full w-full object-cover"
      >
        <source src={videoSources[currentVideo]} type="video/mp4" />
      </video>
      <div className="absolute inset-0 z-10 bg-black/40 bg-gradient-to-b from-black/20 via-transparent to-black/60" />
    </div>
  )
}

export default VideoBackground

